
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { analytics } from "../services/firebaseConnection";
import { logEvent } from "firebase/analytics";


export default function Analytics() {

    const location = useLocation();

    useEffect(() => {

        // não registrar localhost
        if(window.location.hostname === "localhost") {
            return;
        }

        const paginasPublicas = [
            "/",
            "/howitworks",
            "/subscription",
            "/whoweare",
            "/register",
            "/login",
            "/reset",
            "/terms",
            "/lp",
        ];

        if(!paginasPublicas.includes(location.pathname)) {
            return;
        }

        logEvent(analytics, "page_view", {
            page_title: document.title,
            page_location: window.location.href,
            page_path: location.pathname
        });

    }, [location]);

    return null;

}